import { useCallback } from 'react';
import { OrderLegDTO, AssetType, SaveOptions } from '@tradingblock/types';
import { getCustomStrategyLegQuantity } from '@tradingblock/api';
import { useOrderSettings } from '../hooks/useOrderSettings';
import {
  useBlockActions,
  useBlockData,
  useBlockActionDispatchAndGenericActions,
} from '../../../components/blocks/BlockState';
import { DefaultLegs } from '../OrderUtilities';
import { OrderState } from './OrderState';
import { Actions, OrderActions } from './OrderActions';
import { useGroupAssetSymbol } from '../../useGroupState';
import { useOrderActions } from './useOrderActions';

export const useLegsUpdateAction = () => {
  const { setSubstate } = useBlockActions<OrderState>();
  const update = useCallback(
    (orderLeg: OrderLegDTO, options?: SaveOptions | undefined) => {
      setSubstate('legs', orderLeg.Id, orderLeg, options);
    },
    [setSubstate]
  );
  return { update };
};

export const useLegsActions = () => {
  const symbol = useGroupAssetSymbol();
  const settings = useOrderSettings();
  const { legs } = useBlockData<OrderState>();
  const [{ updateData }, dispatch] = useBlockActionDispatchAndGenericActions<OrderState, OrderActions>();
  const { setDebitCredit } = useOrderActions();

  // const updatePartial = useCallback(
  //   (legsToUpdate: PartialOrderLegDTO[], options?: SaveOptions | undefined) => {
  //     const updated = _.reduce(
  //       legs,
  //       (updated, l, k) => {
  //         const updatedLeg = _.find(legsToUpdate, incLeg => incLeg.Id === l.Id) || {};
  //         return {
  //           ...updated,
  //           [k]: {
  //             ...l,
  //             ...updatedLeg,
  //           },
  //         };
  //       },
  //       {} as Legs
  //     );
  //     setField('legs', updated, options);
  //   },
  //   [setField, legs, symbol]
  // );
  const add = useCallback(
    (assetType: AssetType, options?: SaveOptions | undefined) => {
      const initialValues = { assetType, spreadRatio: getCustomStrategyLegQuantity(assetType, settings) };
      const updatedLegs = { ...legs, ...DefaultLegs(legs, symbol, initialValues) };
      updateData(
        {
          legs: updatedLegs,
          recalculatePrice: true,
        },
        options
      );
    },
    [updateData, legs, symbol, settings]
  );
  const remove = useCallback(
    (id: string) => {
      dispatch(Actions.removeLeg({ id }, { persist: true }));
      setDebitCredit();
    },
    [updateData, legs]
  );

  return {
    add,
    remove,
  };
};
